import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DEFAULT_LOCALE, isSupportedLocale } from "@/i18n/locales";
import AnnouncementBar from "./AnnouncementBar.jsx";
import Breadcrumbs from "./Breadcrumbs.jsx";
import Footer from "./Footer.jsx";
import Header from "./Header.jsx";
import ScrollTopButton from "./ScrollTopButton.jsx";
import SEO from "./SEO.jsx";

export default function Layout() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const activeLang = isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;

  useEffect(() => {
    if (!isSupportedLocale(lang)) {
      navigate(`/${DEFAULT_LOCALE}/`, { replace: true });
      return;
    }
    i18n.changeLanguage(activeLang);
  }, [activeLang, i18n, lang, navigate]);

  return (
    <div className="tgwe-app">
      <SEO />
      <Header lang={activeLang} />
      <AnnouncementBar lang={activeLang} />
      <main id="main-content" className="tgwe-main">
        <Breadcrumbs lang={activeLang} />
        <Outlet />
      </main>
      <Footer lang={activeLang} />
      <ScrollTopButton lang={activeLang} />
    </div>
  );
}
